<div
  mat-dialog-title
  class="u-textTruncate u-borderBottom-grey100"
  i18n="@@groupMembershipDialog.title"
>
  Edit {{ data.account.first_name }}'s Membership
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  <form [formGroup]="membershipForm" class="u-paddingTop-16">
    <div class="u-marginBottom-24 u-borderBottom-grey100">
      <p class="u-marginBottom-16 text-subtitle-1">
        <b i18n="@@groupMembershipDialog.membershipDetailsTitle"
          >Membership details</b
        >
      </p>
      <mat-form-field class="mat-form-field-width-100">
        <mat-label i18n="@@global.role">Role</mat-label>
        <mat-select formControlName="role">
          <mat-option *ngFor="let role of data.group.roles" [value]="role.name">
            {{ role.name | translationLookup: ['@@groupRole'] }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      @for (segment of data.group?.custom_segments; track $index) {
        @if (segment.nodes?.length) {
          <div class="u-marginBottom-16">
            <app-group-custom-segment-header
              [customSegment]="segment"
              [user]="data.account"
            ></app-group-custom-segment-header>
            <app-group-segment-node-picker
              class="u-display-block u-marginTop-8"
              [groupCustomSegments]="data.group.custom_segments"
              [membership]="membership"
              [targetCustomSegment]="segment"
              (selectionChanged)="
                segmentSelectionsChanged(membershipForm, segment, $event)
              "
            >
            </app-group-segment-node-picker>
          </div>
        }
      }
    </div>
    <p class="u-marginBottom-16 text-subtitle-1">
      <b i18n="@@groupMembershipDialog.interactionDetailsTitle"
        >Interaction details</b
      >
    </p>
    <mat-form-field class="mat-form-field-width-100">
      <mat-label i18n="@@groupMembershipDialog.visibilityStatusLabel"
        >Visibility Status
      </mat-label>
      <mat-select formControlName="expert_status">
        <mat-option
          value="unrequested"
          i18n="@@groupMembershipDialog.visibilityUnrequested"
        >
          Unrequested
        </mat-option>
        <mat-option
          value="requested"
          i18n="@@groupMembershipDialog.visibilityRequested"
        >
          Requested
        </mat-option>
        <mat-option
          value="approved"
          i18n="@@groupMembershipDialog.visibilityApproved"
        >
          Approved
        </mat-option>
      </mat-select>
    </mat-form-field>
    @if (data?.group?.features_enabled?.introductions) {
      <div class="u-marginTop-16 u-marginBottom-16">
        <mat-slide-toggle
          formControlName="opted_into_matchmaking"
          i18n="@@groupMembershipDialog.toggleIntroductions"
        >
          Introductions
        </mat-slide-toggle>
      </div>
    }
    <div class="u-marginBottom-16">
      <mat-slide-toggle
        formControlName="searchable"
        i18n="@@groupMembershipDialog.toggleSearchable"
      >
        Searchable
      </mat-slide-toggle>
    </div>
    <div class="u-marginBottom-16">
      <mat-slide-toggle
        formControlName="inviteable"
        i18n="@@groupMembershipDialog.toggleInviteable"
      >
        Inviteable
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close i18n="@@global.cancel">
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="saveMembership(data.account, data.group, membershipForm)"
    [disabled]="isLoading"
  >
    <span i18n="@@global.saveChanges">Save changes</span>
    <i
      *ngIf="isLoading"
      class="u-marginLeft-8"
      nz-icon
      nzType="sync"
      nzSpin
    ></i>
  </button>
</mat-dialog-actions>
